export default "__VITE_ASSET__COG2sKTq__"